var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Tabs',{staticClass:"ticket-hub"},[_c('el-card',{staticClass:"contains-table",attrs:{"shadow":"always"}},[_c('time-entry-list',{attrs:{"scope":"cms"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }